module.exports = __webpack_public_path__ + "img/square-chevron-down.f1cf98e4.svg";